import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, CardBody, CardImg} from 'reactstrap';
import classes from './ECB.module.scss';

const ECB = ({assetUrl, altText, link, index}) => {
    const renderButton = link?.buttonVisibility && link?.buttonText;
    const linkCard = link?.linkUrl && !renderButton;

    const cardContent = (
        <>
            <CardImg top src={assetUrl} alt={altText} className={classes.ECBImage} loading="lazy"/>
            {renderButton && (
                <CardBody className={classes.ECBCardBody}>
                    <Button
                        color={link.buttonColor}
                        outline={link.outline}
                        href={link.linkUrl}
                        target={link.linkTarget}
                        className={`anl_ecb--button-${index}`}
                        block
                    >
                        {link.buttonText}
                    </Button>
                </CardBody>
            )}
        </>
    );

    return (
        <Card className={classes.ECBCard}>
            {linkCard ? (
                <a href={link.linkUrl} target={link.linkTarget} rel="noopener noreferrer"
                   className={`anl_ecb--link-${index}`}>
                    {cardContent}
                </a>
            ) : (
                cardContent
            )}
        </Card>
    );
};

ECB.propTypes = {
    assetUrl: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    link: PropTypes.shape({
        linkUrl: PropTypes.string,
        linkTarget: PropTypes.string,
        buttonText: PropTypes.string,
        outline: PropTypes.bool,
        buttonVisibility: PropTypes.bool,
        buttonColor: PropTypes.string,
        index: PropTypes.number
    }),
};

export default ECB;